import { useMemo, useState } from 'react'

const TAB_FIELD_MAP = {
  company: ['officeName', 'commercialRegisterName', 'commercialRegisterNumber'],
  owner: ['ownerName', 'email', 'ownerIdNumber', 'supervisingEmployeeName', 'phoneNumber'],
  address: ['postbox', 'postcode', 'country', 'governorate', 'state', 'area'],
  subscription: ['minimumPriceAllowedForPromotion', 'tenantLowestAge', 'tenantHighestAge', 'deliveryPrice', 'subscriptionType', 'registeredForVat'],
  documents: ['ownerIdCardFile', 'logoFile', 'commercialRegisterFile', 'carRentalAgreementFile'],
}

const TAB_LABELS = {
  company: 'Company',
  owner: 'Owner',
  address: 'Address',
  subscription: 'Subscription',
  documents: 'Documents',
}

const humanize = value =>
  String(value || '')
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    // eslint-disable-next-line
    .replace(/^./, m => m.toUpperCase())

const LeadMagicLinkFieldPickerModal = ({ onSubmit, loading, close }) => {
  const [selectedTabs, setSelectedTabs] = useState([])
  const [selectedFieldsByTab, setSelectedFieldsByTab] = useState({})
  // eslint-disable-next-line
  const hasSelection = useMemo(() => Object.values(selectedFieldsByTab).some(fields => Array.isArray(fields) && fields.length > 0), [selectedFieldsByTab])

  const toggleTab = tab => {
    setSelectedTabs(prev => {
      // eslint-disable-next-line
      if (prev.includes(tab)) {
        const next = prev.filter(item => item !== tab)
        setSelectedFieldsByTab(current => {
          const updated = { ...current }
          delete updated[tab]
          return updated
        })
        return next
      }
      return [...prev, tab]
    })
  }

  const toggleField = (tab, field) => {
    setSelectedFieldsByTab(prev => {
      const fields = prev[tab] || []
      // eslint-disable-next-line
      const nextFields = fields.includes(field) ? fields.filter(item => item !== field) : [...fields, field]
      return { ...prev, [tab]: nextFields }
    })
  }

  const handleSubmit = async () => {
    if (!hasSelection) return
    await onSubmit({
      editableTabs: selectedTabs,
      editableFieldsByTab: selectedFieldsByTab,
    })
    close()
  }

  return (
    <div className="space-y-4">
      <div>
        <p className="text-sm font-semibold text-gray-700 mb-2">Select Tabs</p>
        <div className="grid grid-cols-2 gap-2">
          {/* eslint-disable-next-line */}
          {Object.keys(TAB_FIELD_MAP).map(tab => (
            <label key={tab} className="flex items-center gap-2 text-sm border rounded p-2">
              {/* eslint-disable-next-line */}
              <input type="checkbox" checked={selectedTabs.includes(tab)} onChange={() => toggleTab(tab)} />
              {TAB_LABELS[tab]}
            </label>
          ))}
        </div>
      </div>

      {selectedTabs.map(tab => (
        <div key={tab}>
          <p className="text-sm font-semibold text-gray-700 mb-2">{TAB_LABELS[tab]} Fields</p>
          <div className="grid grid-cols-2 gap-2">
            {TAB_FIELD_MAP[tab].map(field => (
              <label key={field} className="flex items-center gap-2 text-sm border rounded p-2">
                {/* eslint-disable-next-line */}
                <input type="checkbox" checked={(selectedFieldsByTab[tab] || []).includes(field)} onChange={() => toggleField(tab, field)} />
                {humanize(field)}
              </label>
            ))}
          </div>
        </div>
      ))}

      <div className="flex justify-end gap-2 pt-2">
        <button type="button" className="px-4 py-2 text-sm border rounded" onClick={close}>
          Cancel
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-sm text-white rounded ${hasSelection ? 'bg-dark-600 hover:bg-dark-700' : 'bg-gray-300 cursor-not-allowed'}`}
          disabled={!hasSelection || loading}
          onClick={handleSubmit}
        >
          {loading ? 'Sending Link...' : 'Generate & Send Access Link'}
        </button>
      </div>
    </div>
  )
}

export default LeadMagicLinkFieldPickerModal
